export default __webpack_public_path__ + "static/media/csv-upload.dd10f707.svg";